import { jwtDecode } from "jwt-decode";

const getRoles = (decodedToken) =>
  Array.isArray(decodedToken?.roles) ? decodedToken.roles : [];

export const validateTeacherToken = (
  token,
  currentTime = Date.now() / 1000
) => {
  if (!token) {
    return { valid: false, reason: "missing", decoded: null };
  }

  try {
    const decoded = jwtDecode(token);

    if (typeof decoded.exp !== "number" || decoded.exp <= currentTime) {
      return { valid: false, reason: "expired", decoded };
    }

    if (!getRoles(decoded).includes("teacher")) {
      return { valid: false, reason: "teacher-role-required", decoded };
    }

    return { valid: true, reason: "", decoded };
  } catch (error) {
    return { valid: false, reason: "invalid", decoded: null };
  }
};

export const getTeacherAuthErrorMessage = (reason) => {
  if (reason === "expired") {
    return "Your session has expired. Please sign in again.";
  }

  if (reason === "teacher-role-required") {
    return "This portal is available to teacher accounts only.";
  }

  if (reason === "invalid") {
    return "Your session could not be validated. Please sign in again.";
  }

  return "Please sign in to continue.";
};
